import { Component, Inject } from '@angular/core';

import { SessionManager } from '@shared/app/scripts/services/session-manager';

import {
  faBars,
  faBuilding,
  faExchange,
  faLifeRing,
  faSignOut,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';

import './new-sw-header.scss';

/**
 * ng11 replacement for {@link SwHeader}
 */
@Component({
  selector: 'new-sw-header',
  template: require('./new-sw-header.html').default,
})
export class NewSwHeaderComponent {
  faBars = faBars;
  faBuilding = faBuilding;
  faExchange = faExchange;
  faLifeRing = faLifeRing;
  faSignOut = faSignOut;
  faUser = faUser;

  showMenu = false;

  constructor(@Inject(SessionManager) private sessionManager: SessionManager) {}

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  logout() {
    return this.sessionManager.logout();
  }
}
